import { render } from "./AdditionalCharges.vue?vue&type=template&id=72a6e118&scoped=true"
import script from "./AdditionalCharges.vue?vue&type=script&lang=js"
export * from "./AdditionalCharges.vue?vue&type=script&lang=js"

import "./AdditionalCharges.vue?vue&type=style&index=0&id=72a6e118&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a6e118"]])

export default __exports__